import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, KeyValueDiffers, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationStart, Params, Router } from '@angular/router';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Observable, Subscription } from 'rxjs';
import { MeetingService } from 'src/app/service/meeting.service';
import { CodeList, MeetingResponse } from 'src/app/models/basicMeetingModel';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { UtilityService } from 'src/app/service/utility.service';
import { environment, environment_const, environment_msg } from 'src/environments/environment';
import { AttendeeService } from 'src/app/service/attendee.service';
import { Popover } from 'bootstrap';
import { FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Globals } from 'src/app/service/global';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ParticReviewSelectDialogComponent } from 'src/app/components/partic-review-select-dialog/partic-review-select-dialog.component';
import { PreviewMinutesDialogComponent } from 'src/app/components/preview-minutes-dialog/preview-minutes-dialog.component';
import { WebsocketService } from 'src/app/service/websocket.service';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import {TrackAttendeeDialogComponent} from '../../components/track-attendee-dialog/track-attendee-dialog.component';
import { ShortcutDialogComponent } from 'src/app/components/shortcut-dialog/shortcut-dialog.component';
import { CancelMeetingPopupComponent } from 'src/app/components/cancel-meeting-popup/cancel-meeting-popup.component';
import { BreakpointState } from '@angular/cdk/layout';
import {
  BreakpointObserver,
  Breakpoints,
} from '@angular/cdk/layout';
import { CreateMeetingComponent } from '../create-meeting/create-meeting.component';
import { SaveTemplateDialogComponent } from 'src/app/components/save-template-dialog/save-template-dialog.component';
import { CopymeetingComponent } from 'src/app/components/copymeeting/copymeeting.component';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_FORMATS } from 'src/app/components/grid-table/grid-table.component';
import { InstantMeetingDescriptionComponent } from 'src/app/components/instant-meeting-description/instant-meeting-description.component';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { MomService } from 'src/app/service/mom.service';
import { ViewMomDialogComponent } from 'src/app/components/view-mom-dialog/view-mom-dialog.component';
@Component({
  selector: 'app-approved-meeting-page',
  templateUrl: './approved-meeting-page.component.html',
  styleUrls: ['./approved-meeting-page.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]
})
export class ApprovedMeetingPageComponent implements OnInit, OnDestroy, OnChanges {

  toppings = new UntypedFormControl();
  toppingList: string[] = ['Agenda 1', 'Agenda 2', 'Agenda 3', 'Agenda 4', 'Agenda 5'];
  //today Meeting Date variable 
  todayMeeting : any
  private readonly notifier!: NotifierService;
  //meeting end
  meetingEnded = false
  showCkEditorPanel = false
  meetingTitleEdit!: string;
  meetingDateStr : any;
  duration:any;
  meetingStartTime:any;
  //UI changes
  dateChangeContent: any;
  minuteChangeContent : any;
  secondsChangeContent : any
  paneDirection = false;
  pinDialogTriggered = false
  curPkMomDetailId:any;
  options: any
  today: any
  currentDate: any
  isAllMomApproved=false;
  //accordion opener variable
  sectionOpener : any
  participantExpansion = true;
  isLoading:boolean=false;
  //instant meeting started variable
  meetingStarted = false;
  @Input() instantMeetingStarted = false;
  instantMeetingTriggeredFromDropDown = false
  @ViewChild(InstantMeetingDescriptionComponent) insDescpComp !: InstantMeetingDescriptionComponent;
  //two pane
  rightPane = 0;
  leftPane = 100;
  videoPane = 20;
  checker : any;
  guestFromLink : any;

  //pin div dialog
  pinDialogOpener = false
  pinDiv = false

  mediaSub!: Subscription;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;
  meetingType: any;
  @Input() meetingResponse!: MeetingResponse;
  meetingTypeResponse!: CodeList;
  meetingMediumResponse!: CodeList;
  meetingTitle: any;
  meetingTitleChanges: any;
  meetingJSON: any;
  scheduleMsg: string="";
  meetingRespDiffer: any;
  momList:any[]=[];
  showMomVariable = false
  meetingTypeChecker : any;
  matDialogCancel!:MatDialogRef<CancelMeetingPopupComponent>
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  matDialogRef!: MatDialogRef<CopymeetingComponent, any>;
  selectParticiDialogRef!: MatDialogRef<ParticReviewSelectDialogComponent, any>;
  isMeetingModified:any
  showStart:boolean=true;
  requestVal:any;
 
  constructor(private readonly breakpointObserver: BreakpointObserver,public datepipe: DatePipe,public serviceToCheck: FreeFormMinutesService, private dialog : MatDialog, public sideNav : SideNavServiceService,
     private router: Router, private globals: Globals, public mediaObserver: MediaObserver, private activatedroute: ActivatedRoute, private meetingService: MeetingService, public cdr: ChangeDetectorRef, private commonService: FreeFormAgendaService, private utilityService: UtilityService, private attendeeService: AttendeeService,notifierService: NotifierService, private spinner:NgxSpinnerService,private differs: KeyValueDiffers,
     private websocketService:WebsocketService,private webTranService:WebsocketTransferService,private momService:MomService) {
    //utilityService.loadExternalScript(environment.ckeditorScriptUrl);
    this.momList=[];
    this.serviceToCheck.setActivateCkEditor(false)
    this.meetingRespDiffer = this.differs.find({}).create();
    this.notifier = notifierService;
    this.guestFromLink = localStorage.getItem('isGuest');
    this.spinner.show();
    this.activatedroute.queryParams.subscribe(
      (response: any) => {
   
        if (response.meetingResult != null && response.meetingResult != undefined) {
          var meetingInfo = JSON.parse(response.meetingResult);
          this.requestVal = JSON.parse(response.meetingResult);
          this.meetingTitleChanges=null;
          this.dateChangeContent = null;
          this.minuteChangeContent = null;
          this.secondsChangeContent = null;
          //UI Team Changes
          this.meetingEnded = meetingInfo.showMoM
          if(this.meetingEnded == true){
            this.meetingStarted = true
          }
          if(meetingInfo.showMoM == true){
            this.showMomVariable = meetingInfo.showMoM
          }
          this.meetingResponse = meetingInfo;
          //alert("meeting information"+meetingInfo.meetingStatusCode);
          this.meetingTypeResponse = meetingInfo;
          this.fetchAndAssignMeetingInfo(meetingInfo);
          ////consolee.log("meetingResponse",this.meetingResponse)          
          this.todayMeeting = new Date(this.meetingResponse.meetingDateFullFormat).toDateString()
          ////consolee.log("today meeting",this.todayMeeting)
          //code added for showing start button flag
         
        }
      }
    );
   this.activatedroute.queryParams.subscribe(
    params => {
      ////consolee.log("MeetingID**"+params['meetingId']);
    }
  )
    this.commonService.observeMeetingResponse()?.subscribe((value:any) => {
      
      
      if(value!=undefined){
        if(value.elementType=="ENDMEETING"){
          
          this.meetingEnded = true
          this.sideNav.openInstantMeeting(false);
          var sucMes = 'Meeting Ended By '+value.sentByUserName;
          this.notifier.show({
            type: 'success',
            message: sucMes
          });
          this.meetingResponse.elementType="";
          value.elementType="";
        }else if(value.elementType=="STARTMEETING"){
          this.sideNav.openInstantMeeting(true)
          this.participantExpansion = true
          this.instantMeetingStarted = !this.instantMeetingStarted
          this.rightPane = 0;
          this.leftPane = 100;
          this.meetingStarted = true
          this.meetingResponse.elementType="";
          value.elementType="";
        }
      }
    });
    attendeeService.fetchUserListSource("Y");
    this.meetingService.fetchMeetingTypeInfo().then((meetingType: any) => { this.meetingTypeResponse = meetingType });
    this.meetingService.fetchMeetingMedium().then((meetingMedium: any) => { this.meetingMediumResponse = meetingMedium });
    ////consolee.log("Schedule component meeting type", this.meetingType)

  }

  ngOnChanges() {
  } 

  hideVideoPane(number : any){
    this.videoPane = number
  }

  //pin dialog function

  pinDialog() {
    this.pinDiv = !this.pinDiv
    // this.pinDiv = true
    if(this.pinDiv == true){   
      this.sideNav.BackDropEnabler(false)   
      this.rightPane = 50
      this.leftPane = 50
    }
    else{
      this.leftPane = 100
      this.rightPane = 0
      this.sideNav.BackDropEnabler(true)
    }
  }

  //pin dialog opener function

  opePinDialog($event: any) {
    this.pinDialogOpener = !this.pinDialogOpener;
    ////consolee.log("pinDialogOpener",this.pinDialogOpener)
  }

  closeRightPinOpener() {
    this.pinDialogOpener = false
    this.sideNav.BackDropEnabler(false)
    this.leftPane = 100;
    this.rightPane = 0
  }

  //UI Team changes.
  //commented below code on 14th May. Due to timezone issue
  minuteContentChanger(minutes : any){
 
    this.minuteChangeContent = minutes
 
    this.meetingStartTime = minutes;
  }

  getCurrentStatus(status:any){
    if(status=='COM'){
      this.meetingEnded=true;
      this.sideNav.openInstantMeeting(false);
    }
  }

  cancelMeetingPopup(meetingId:any){
   
    this.matDialogCancel = this.dialog.open(CancelMeetingPopupComponent, {

      data:{
        meetingId
      },
      position : {
        left : "0%"
      },
      panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: false,
      maxWidth: "100%",
      maxHeight: "100vh",
      width : "50%"
      // disableClose: true

    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        this.matDialogCancel.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        this.matDialogCancel.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogCancel.updateSize('100vw', '100vh');
      } 
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    this.matDialogCancel.afterClosed().subscribe((data)=>{
      // this.meetingDatasource.loadUpcomingMeetings(this.meetingJSON);
      // this.meetingDatasource.loadPastMeetings(this.meetingJSON);
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['dashboard']);
      this.sideNav.openInstantMeeting(false);
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
    });
  }

  //UI Team changes
  secondsContentChanger(seconds : any){
    this.secondsChangeContent = seconds
  
    this.duration = seconds;
  }

  //accordion opener
  getValue(data : any){
    ////consolee.log("data to check", data )
    this.sectionOpener = data
  }
  startMeeting(meetingId:any){
    var jsonObj = {
      "meetingId":meetingId,
      "userId":localStorage.getItem("userId")
    }
    let closeIcon = <HTMLElement>document.getElementById('close-icon-desc');
   
    closeIcon.click()
    this.meetingService.startMeeting(jsonObj).subscribe(
      (meetingRes: any) => {
        //
        this.sideNav.openInstantMeeting(true);
        this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meetingId }) }, skipLocationChange: true, replaceUrl: false });  
       },
      err => {
        //
      })
      this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.meetingResponse).subscribe((data) => {
      });
    }
  instantMeeting() {
    this.sideNav.openInstantMeeting(true)
    this.participantExpansion = true
    this.instantMeetingStarted = !this.instantMeetingStarted
    // this.sideNav.triggerMeetingAlert(this.instantMeetingStarted)
    // this.instantMeetingStarted = !this.instantMeetingStarted
    // this.rightPane = 0;
    this.leftPane = 100;
    this.meetingStarted = true
    // return this.router.navigate(['instantMeeting'])

    this.meetingResponse.addType='A';
    this.meetingResponse.elementType='STARTMEETING';
    var sentUserName = localStorage.getItem("userName");
    if(sentUserName!=null && sentUserName!=undefined){
      this.meetingResponse.sentByUserName=sentUserName;
    }
    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.meetingResponse).subscribe((data) => {
    });

  }

  boolean = true

  ngDoCheck(){
    if(this.sideNav.openInstantMeetingTransmitter() == true){
      this.participantExpansion = false;
      this.instantMeetingStarted = true
      // this.sideNav.triggerMeetingAlert(this.instantMeetingStarted)
      // this.instantMeetingStarted = !this.instantMeetingStarted
      // this.rightPane = 0;
      this.leftPane = 100;
      this.meetingStarted = true
      this.meetingEnded = false
      // //
    }
    if(this.deviceXl || this.deviceLg){
      this.paneDirection = false
    }
    else{
      this.paneDirection = true
    }
    let imageBtnlabel = document.getElementsByClassName('cke_dialog_ui_button');
    if(imageBtnlabel){
      for(var i = 0; i < imageBtnlabel.length; i++){
        if(imageBtnlabel[i].textContent == 'Send it to the Server'){
          imageBtnlabel[i].textContent = 'Upload'
          imageBtnlabel[i].setAttribute('style','padding: 4px 8px; margin: 0;text-align: center; color: #333; vertical-align: middle; cursor: pointer; border: 1px solid #b6b6b6; border-bottom-color: #999; border-radius: 3px;box-shadow: 0 1px 0 rgb(255 255 255 / 50%), 0 0 2px rgb(255 255 255 / 15%) inset, 0 1px 0 rgb(255 255 255 / 15%) inset; background: #e4e4e4;background-image: linear-gradient(to bottom,#fff,#e4e4e4);')
            }
        if(imageBtnlabel[i].textContent == 'OK'){
          //imageBtnlabel[i].setAttribute('style','display : none')
        }
        if(imageBtnlabel[i].textContent == 'Cancel'){
          imageBtnlabel[i].textContent = 'close'
          imageBtnlabel[i].setAttribute('style','padding: 4px 8px; margin: 0;text-align: center; color: #333; vertical-align: middle; cursor: pointer; border: 1px solid #b6b6b6; border-bottom-color: #999; border-radius: 3px;box-shadow: 0 1px 0 rgb(255 255 255 / 50%), 0 0 2px rgb(255 255 255 / 15%) inset, 0 1px 0 rgb(255 255 255 / 15%) inset; background: #e4e4e4;background-image: linear-gradient(to bottom,#fff,#e4e4e4);')

        }
      }      
    }
    let imageText = document.getElementsByClassName('cke_dialog_ui_labeled_label');
    for(let i=0 ; i < imageText.length; i++){
    if(imageText[i]){
      //imageText[i].textContent='Select a file to upload'
    }
  }
    // if(this.serviceToCheck.returnActivateCkEditor() == true){
    //   this.showCkEditorPanel = true
    
    // }
    if(this.guestFromLink == '1' && this.guestFromLink != null && this.guestFromLink != undefined){    
      this.sideNav.disablePages() 
    }
  }

  //UI Team Change
  closeInstantMeeting(meetingResponse: any){
    var reqJson={"meetingId":meetingResponse.meetingId,"userId":this.globals.userId,"visitorTimeZone":this.globals.vTimeZone};
    this.meetingService.endMeeting(reqJson).subscribe(
      (meetingRes: any) => {
        ////consolee.log("meeting resp frm end meeting" + JSON.stringify(meetingRes));
        this.notifier.show({
          type: 'success',
          message: 'Meeting Ended Successfully'
        });
       
       // this.meetingResponse = meetingRes.body;
        //this.commonService.shareDatatoService(this.meetingResponse);
        if(meetingRes!=null && meetingRes.body!=null){
          this.meetingResponse.meetingStatusCode = meetingRes.body.meetingStatusCode;
          this.meetingResponse.pkMomDetailId=meetingRes.body.pkMomDetailId;
          this.momList=meetingRes.body.momDetailList;
          this.curPkMomDetailId=meetingRes.body.pkMomDetailId;
        }
        this.meetingEnded = true
        this.sideNav.openInstantMeeting(false);
        this.meetingResponse.addType='A';
        this.meetingResponse.elementType='ENDMEETING';
        var sentUserName = localStorage.getItem("userName");
        if(sentUserName!=null && sentUserName!=undefined){
          this.meetingResponse.sentByUserName=sentUserName;
        }
        this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.meetingResponse).subscribe((data) => {
        });
      },
      err => {
        //
        //this.ngxSpinner.hide();
      })
     
  }

  booleanEmit(event : any){
    this.meetingEnded = event
  }
  checkAllMomApproved(){
    this.isAllMomApproved=false;
    if(this.momList!=undefined && this.momList!=null && this.momList.length>0){
      this.momList.forEach((element:any) => {
        if(element!=null && element.momStatusCode!=null && element.momStatusCode!=undefined && (element.momStatusCode==environment_const.momApproveStatus)){
          this.isAllMomApproved=true;
        }
      });
    }
  }

  //openPreviewSelectedParticipantsDialog()
  openPreviewSelectedParticipantsDialog(){
    this.checkAllMomApproved();
    if(this.momList==null || this.momList==undefined || this.momList.length<=0){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_create_mom
      });
    }
    else if(this.isAllMomApproved){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_already_approved
      });
      return false;
    }
    this.momService.fetchAgendaMinutesCount(this.meetingResponse.meetingId).subscribe((resp:any)=>{
 
      if(resp!=null && resp!=undefined && resp.count!=undefined && resp.count<=0){
   
        this.notifier.show({
          type: 'error',
          message: environment_msg.msg_error_enter_notes_to_draft
        });
        return false;
      }else{
        this.callReviewDraftDialog();
        return true;
      }
    });
    return true;
  }
  callReviewDraftDialog(){
    var reviewSelect = this.dialog.open(ParticReviewSelectDialogComponent,{
      data: {title : "Participants Review Selection",curPkMoMDetailId:this.curPkMomDetailId,momList:this.momList,generateNewCon:"Y",
              meetingResp : this.meetingResponse},
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                 
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    });
    reviewSelect.afterClosed().subscribe((data:any)=>{
      this.fetchMoMDetailListByMeeting();
     });
  }

  //openMoMSelectApprovalDialog()
  openMoMSelectApprovalDialog(){
    this.checkAllMomApproved();
    if(this.momList==null || this.momList==undefined || this.momList.length<=0){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_create_mom
      });
    }
    else if(this.isAllMomApproved){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_already_approved
      });
      return;
    }
    this.momService.fetchAgendaMinutesCount(this.meetingResponse.meetingId).subscribe((resp:any)=>{
 
      if(resp!=null && resp!=undefined && resp.count!=undefined && resp.count<=0){
   
        this.notifier.show({
          type: 'error',
          message: environment_msg.msg_error_enter_notes_to_approve
        });
        return false;
      }else{
        this.callMomApproveDialog();
        return true;
      }
      
    });
    return true;
  }
  callMomApproveDialog(){
    this.selectParticiDialogRef = this.dialog.open(ParticReviewSelectDialogComponent,{
      data: {title : "MOM Approval Selection",
              meetingResp : this.meetingResponse,curPkMoMDetailId:this.curPkMomDetailId,momList:this.momList,generateNewCon:"Y",
              reviewType  : "APPROVE"},
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                 
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    });
    this.selectParticiDialogRef.afterClosed().subscribe((data:any)=>{
     
     this.fetchMoMDetailListByMeeting();
      if(data!=null && data.momStatus!=null){
        this.meetingResponse.commonMomStatusCode=data.momStatus;
      }
      
    });
  }
  goToMoM(){
    this.momService.fetchAgendaMinutesCount(this.meetingResponse.meetingId).subscribe((resp:any)=>{
 
      if(resp!=null && resp!=undefined && resp.count!=undefined && resp.count<=0){
        this.notifier.show({
          type: 'error',
          message: environment_msg.msg_error_enter_notes_to_mom
        });
        return false;
      }else{
        this.router.navigate(['MoM'], { queryParams: { "meetingResult": JSON.stringify(this.meetingResponse), "approved" : true }, skipLocationChange: true, replaceUrl: false });  
        return true;
      }
    });
    //this.router.navigate(['MoM'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : this.meetingResponse.meetingId,"meetingTitle":this.meetingResponse.meetingTitle,"meetingDate":this.meetingResponse.meetingDateFullFormat,"timezone":this.meetingResponse.tzName,"duration":this.meetingResponse.duration,"meetingTime":this.meetingResponse.meetingStartTime }) }, skipLocationChange: true, replaceUrl: false });  
    return true;
  }
  
  previewMinutesDialog(meetingResp:any){
    this.checkAllMomApproved();
    if(this.momList==null || this.momList==undefined || this.momList.length<=0){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_create_mom
      });
    }
    else if(this.isAllMomApproved){
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_already_approved
      });
      return;
    }
    this.momService.fetchAgendaMinutesCount(this.meetingResponse.meetingId).subscribe((resp:any)=>{
 
      if(resp!=null && resp!=undefined && resp.count!=undefined && resp.count<=0){
        this.notifier.show({
          type: 'error',
          message: environment_msg.msg_error_enter_notes_to_preview
        });
        return false;
      }else{
        this.callPreviewDialog(meetingResp);
        return true;
      }
     
    });
    return true;
  }

  callPreviewDialog(meetingResp:any){
 
    let previewMinutes = this.dialog.open(PreviewMinutesDialogComponent,{
      data:{meetingInfo:meetingResp,momList:this.momList,generateNewCon:"Y",curPkMoMDetailId:this.curPkMomDetailId},
      panelClass: ['parent-dialog-container'],
      maxWidth : "100%",
      maxHeight : "100vh",
      minWidth : "80%",
      minHeight : "80vh",
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        previewMinutes.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        previewMinutes.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        previewMinutes.updateSize('100vw', '100vh');
      } 
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    previewMinutes.afterClosed().subscribe((data)=>{
      this.fetchMoMDetailListByMeeting();
      mediumDialogSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });
  }

  dateContentChanger(value : any){
    this.dateChangeContent = value
    var meetingDate = this.datepipe.transform(value, "MMM dd, YYYY");
  
    this.meetingDateStr = meetingDate;
  }

  ngAfterViewInit(){
    // setTimeout(() => {      
    // },1000)
    // let meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
    // meetingTitleChanger.contentEditable = 'false'
    this.fetchMoMDetailListByMeeting();
  }

  ngOnInit(): void {
    // let OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');
    
    this.options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }

    
    
    // if(this.sideNav.openInstantMeetingTransmitter() == false){
     
  
    if(this.showMomVariable){
      // window.alert("past meeting")
      let editIcon = (<HTMLElement>document.getElementById('edit-icon'))
            editIcon.hidden = false;
            let dateDetails = <HTMLElement>document.getElementById('date-details');
            dateDetails.hidden = false
            // editIcon.click()
            let OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');
            
            let displays = window.getComputedStyle(OpenMeetingInfo, null).display
           
            if(displays == 'inline'){
              $("#OpenMeetingInfo").toggle()
            }
            let meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
            meetingTitleChanger.contentEditable = 'false'
            meetingTitleChanger.style.border = '0px';
            // let meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
            // meetingTitleChanger.contentEditable = 'false'
    }

  this.mediaSub = this.breakpointObserver.observe([
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge
  ]).subscribe(result => {
    const breakpoints = result.breakpoints;

    this.deviceXs = breakpoints[Breakpoints.XSmall] || false;
    this.deviceSm = breakpoints[Breakpoints.Small] || false;
    this.deviceMd = breakpoints[Breakpoints.Medium] || false;
    this.deviceLg = breakpoints[Breakpoints.Large] || false;
    this.deviceXl = breakpoints[Breakpoints.XLarge] || false;
  });
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US", this.options)
  }

  ngOnDestroy() {
    this.mediaSub?.unsubscribe();    
    this.insDescpComp.updateRecurFields();
    if(localStorage.getItem("userId")!=null){
      if(this.requestVal['isMeetingRunning'] != null && this.requestVal['isMeetingRunning']!=undefined && this.requestVal['isMeetingRunning']==true) {
          var reqJson={"meetingId":this.meetingResponse.meetingId,"userId":localStorage.getItem("userId"),"loggedStatus":"LOGOUT"}
          this.webTranService.pushUserLoggedInStatus(this.meetingResponse.meetingId,reqJson).subscribe((data) => {
          
          this.meetingResponse.elementType='EXITMEETING';
          this.meetingResponse.elementId=""+this.globals.userId
          var sentUserName = localStorage.getItem("userName");
          if(sentUserName!=null && sentUserName!=undefined){
            this.meetingResponse.sentByUserName=sentUserName;
          }
          this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.meetingResponse).subscribe((data) => {
            
            this.websocketService._disconnect();
          });
        
          
        });
      }else{
        this.websocketService._disconnect();
      }
    }
   
    
  }
  getLatestMeetingResponse(data:any){
    //alert("currentMeetingResponse>>>"+JSON.stringify(data));
    
    this.meetingResponse = data;
  }

  fetchMoMDetailListByMeeting(){
    return new Promise(async (resolve, reject) => {
      await this.momService.fetchMoMDetailListByMeeting(this.meetingResponse.meetingId).subscribe(res => {
        if (res.body != null && res.body != undefined) {
          this.momList=res.body;
     
          if(res.body[0]!=undefined && res.body[0]!=null){
            this.curPkMomDetailId=res.body[0]!.pkMomDetailId;
          }
          resolve(this.momList);
        }
      });
    });
  }
  //Method to fetch and assign value to meeting interface/model
  fetchAndAssignMeetingInfo(meetingInfo: any) {
    this.meetingTitleChanges=null;
    var jsonObj: any = {};
    if(meetingInfo['searchValue']!=undefined && meetingInfo['searchValue'] !="" ){
    localStorage.setItem("searchValue",JSON.stringify(meetingInfo['searchValue']));
    }
    if(meetingInfo['tasksearchValue']!=undefined && meetingInfo['tasksearchValue'] !="" ){
    localStorage.setItem("tasksearchValue",JSON.stringify(meetingInfo['tasksearchValue']));
    }
    this.spinner.show();
    if (meetingInfo['meetingId'] != null) {
      //this.ngxSpinner.show();
      if(meetingInfo['isConfidential']=="Y"){
        jsonObj = {
          "meetingId": meetingInfo['meetingId'],
          "userId": this.globals.userId,
          "deletedFlag": 0,
          "rowStatus":"",
          "decryptKey":meetingInfo['decryptKey'],
          "visitorTimeZone":this.globals.vTimeZone,
          "meetingUTCDate":meetingInfo['meetingObj'].meetingUTCDate,
          "meetingDate": meetingInfo['meetingObj'].meetingDate,
           "meetingStartTime": meetingInfo['meetingObj'].meetingStartTime,
           "meetingDateStr":meetingInfo['meetingObj'].meetingDateStr,
        }
   
        //this.isLoading=true;
        this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(
        (meetingRes: any) => {
          this.meetingInfoData(meetingRes);
          this.spinner.hide();
        },
        err => {
        }).add(() => {
         // this.spinner.hide();
        });
      }
      else{
      this.meetingService.fetchMeetingInfo(meetingInfo['meetingId']).subscribe(
        (meetingRes: any) => {
          this.meetingInfoData(meetingRes);
          this.spinner.hide();
        },
        err => {
        }).add(() => {
          //this.spinner.hide();
        });
    }
  }
  }
  meetingInfoData(meetingRes:any){
    this.meetingResponse = meetingRes.body;
          this.commonService.shareDatatoService(this.meetingResponse);
          this.websocketService._connect();
          this.meetingResponse.elementType='JOINMEETING';
          this.meetingResponse.elementId=""+this.globals.userId;
          var sentUserName = localStorage.getItem("userName");
          if(sentUserName!=null && sentUserName!=undefined){
            this.meetingResponse.sentByUserName=sentUserName;
          }
          this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.meetingResponse).subscribe((data) => {
          });
          if(this.meetingResponse.meetingStatusCode == 'BSCH' || this.meetingResponse.meetingStatusCode == 'SCH' && this.sideNav.openInstantMeetingTransmitter() == false){
            this.sideNav.openInstantMeeting(false) 
            document.getElementById('edit-icon')?.click()
            let editIcon = (<HTMLElement>document.getElementById('edit-icon'))
            editIcon.hidden = true
            let dateDetails = <HTMLElement>document.getElementById('date-details');
            dateDetails.hidden = true
            let OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');
            let displays = window.getComputedStyle(OpenMeetingInfo, null).display
            if(displays != 'inline'){
              let meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
              meetingTitleChanger.contentEditable = 'true'
            }
          let closeIcon = <HTMLElement>document.getElementById('close-icon-desc');
          closeIcon.hidden = false;
        }
        if(this.meetingResponse.meetingUTCDate!=undefined){
          var meetUTCDate = new Date(this.meetingResponse.meetingUTCDate);
          var todayDate = new Date();
          if(meetUTCDate.getUTCDate()>todayDate.getUTCDate()){
            this.showStart=false;
          }
        }
        //close
          // this.setData();

          //this.cdr.markForCheck();
          //this.ngxSpinner.hide();
          if(this.meetingResponse.meetingUTCDate!=undefined){
            
             var curSysDate = new Date(this.meetingResponse.meetingUTCDate);
             var meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
             var fullDate = new Date(meetUtc + (3600000*(this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
             var hour=this.addZero(fullDate.getHours());
             var minutes=this.addZero(fullDate.getMinutes());
             this.meetingStartTime = hour+":"+minutes;
            //  this.meetingDateSet = fullDate
             
            //  this.dateContentEmit.emit(this.meetingDateSet)
            //  this.minuteContentEmit.emit(this.meetingStartTime);
           }
        }
    
  
  //this method is used to change the meeting title
  meetingTitleChange(e: any) {
    this.meetingTitleChanges = e;
    //  //
  }

  //track attendee dialog
  trackAttendeeDialog(){
    this.dialog.open(TrackAttendeeDialogComponent, {
      panelClass : "base-class-dialog",
      disableClose: false,
      maxWidth: "100%",
      maxHeight: "100vh",
      width : "95%"
    });
  }


  scheduleMeeting(meetingId:number,code:any){
    this.spinner.show();
    if(code =='BSCH'){
      this.meetingJSON ={
        "meetingId":meetingId,
      };
    }else{
    this.meetingJSON ={
      "meetingId":meetingId,
      "rescheduleFlag":"Y"
     

    }
  };
   // this.meetingJSON.meetingFrequency ="N";
    //this.meetingJSON.recurMeetingFlag ="";
    this.meetingJSON.orgCode =localStorage.orgCode;
    this.meetingJSON.orgCode=localStorage.getItem("orgCode");
    this.meetingService.scheduleMeeting(this.meetingJSON).subscribe(res => {
      var resp = res.body;
      this.scheduleMsg = resp['scheduleMsg'];
      this.spinner.hide();
      if(this.scheduleMsg!=null && this.scheduleMsg=="YES"){
        this.notifier.notify("success","The meeting scheduled successfully");
      }

      this.router.navigate(['dashboard'])
    }, err => {
      this.spinner.hide();
    });
    
  }

  beforeScheduleMeeting(meetinObj:any,code:any){
 
 
    if(this.utilityService.nvl(this.insDescpComp.selectedFrequency)!="" && this.insDescpComp.selectedFrequency!='N'  && this.meetingResponse.recurDetailsId==null){
      if(this.utilityService.nvl(this.insDescpComp.recurTillDateStr.value)!=""){
        this.insDescpComp.updateTillDate(meetinObj.meetingId).then(()=>{
          this.createRecurParentMeeting(meetinObj.meetingId,code);    
        });
      }else{
        this.insDescpComp.recurTillDateStr.markAsTouched();//([Validators.required]);
      }
    }else{
      this.scheduleMeeting(meetinObj.meetingId,code);
    }
  }

  createRecurParentMeeting(meetingId:any,code:any){
    var reqJson ={
      "meetingId":meetingId,
      "userId": this.globals.userId,
      "visitorTimeZone":this.globals.vTimeZone
    }
    this.spinner.show();
    this.meetingService.createRecurParentMeeting(reqJson).subscribe(res => {
      this.scheduleMeeting(meetingId,code);
    }).add(() => {
      this.spinner.hide();
    });
  }

  isOpenMeetingInfo(){
    let OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');
   
    let displays = window.getComputedStyle(OpenMeetingInfo, null).display
   
    if(displays == 'none'){
      $("#OpenMeetingInfo").toggle()
    }
    let meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
    meetingTitleChanger.contentEditable = 'true'
    // meetingTitleChanger.click()
    meetingTitleChanger.focus()
    meetingTitleChanger.style.borderBottom = '2px dashed black';
    let editIcon = <HTMLElement>document.getElementById('edit-icon');
    editIcon.hidden = true;
    let dateDetails = <HTMLElement>document.getElementById('date-details');
    dateDetails.hidden = true
   }

   showEditIconAfterBlur(){
      let meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
      meetingTitleChanger.contentEditable = 'false'
      let editIcon = <HTMLElement>document.getElementById('edit-icon');
      editIcon.hidden = false;
      meetingTitleChanger.style.borderBottom = '0px';
   }
 
   isOpenShortcutView(){
     this.dialog.open(ShortcutDialogComponent,{
       panelClass: ['animate__animated','animate__slideInRight'],
       disableClose: true,
       position : {
         left : "85%"
       },
       maxWidth: "100%",
       maxHeight: "100vh",
       width : "20%",
       height : "100vh",
       hasBackdrop: false
     });
     let openShortCut = <HTMLElement>document.getElementById('open-short-cut');
     openShortCut.setAttribute('disabled','true')
   }

   triggerLinkMeetingFromDescription(bool : boolean){
    if(bool == true){
      this.openPreviousMeetingHistoryDailog()
    }
   }

   copyMeeting(meeting:any){

  

    this.matDialogRef = this.dialog.open(CopymeetingComponent, {
      data:{meeting},
      panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: false,
      position : {
        left : "0%"
      },
      maxWidth: "100vw",           
      maxHeight: "100vh",
      width: "50%",
      height : "100vh"
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        this.matDialogRef.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        this.matDialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogRef.updateSize('100vw', '100vh');
      } 
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });

    this.matDialogRef.afterClosed().subscribe((data)=>{
      // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      // this.router.onSameUrlNavigation = 'reload';
      // this.router.navigate(['dashboard']);
      smallDialogSubscription.unsubscribe();
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });

  }

   openPreviousMeetingHistoryDailog() {
    this.pinDialogTriggered = true
    this.rightPane = 50;
    let matTabHeader = document.getElementsByClassName('mat-tab-header');
    let matTabBodyWrapper = document.getElementsByClassName('mat-tab-body-wrapper');
    let OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');
    // let linkTabContainer = document.getElementById('link-tab-container');
    // let linkedTabContainer = document.getElementById('linked-tab-container');
  
    
    
    let displays = window.getComputedStyle(OpenMeetingInfo, null).display
   
    if(displays == 'inline'){
      $("#OpenMeetingInfo").toggle()
    }
    let meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
    let editIcon = <HTMLElement>document.getElementById('edit-icon');
    editIcon.hidden = false;
    let dateDetails = <HTMLElement>document.getElementById('date-details');
    dateDetails.hidden = false
    meetingTitleChanger.contentEditable = 'false'
    meetingTitleChanger.style.borderBottom = '0px';
    // let participantAccordionContainer = <HTMLElement>document.getElementById('participant-accordion-container');
    
    // if(this.participantExpansion == true){
    //   participantAccordionContainer.click()
    // }
    // this.participantExpansion = false
    setTimeout(() => {
     
     
      matTabHeader[0].setAttribute('style','margin-top : 10px!important')
      matTabBodyWrapper[0].setAttribute('style','height : calc(100vh - 150px)!important; overflow : hidden!important')
      // linkTabContainer?.setAttribute('style','height: calc(100vh - 194px);width: 100%;overflow-y: auto;')
      // linkedTabContainer?.setAttribute('style','height: calc(100vh - 194px);width: 100%;overflow-y: auto;')
    },700)
    this.sideNav.dialogCheckedChecker(false)
    // this.sideNav.dialogCheckedEmitter()
  }

  useTemplate(meetingId:any, meetingType : any){
   
    this.meetingService.getCategoryDetails().subscribe(response => {
      
      this.router.navigate(['templateView'],{queryParams:  {'response':response,'meetingType':meetingType, 'meetingId':meetingId,'calledFrom':'MUT'},skipLocationChange: true, replaceUrl: false})
    });
    // this.meetingService.getCategoryDetails().subscribe(response => {
    //   
    //    let useTemplateDialog = this.dialog.open(CreateMeetingComponent,{
    //      data:{response,meetingId}
    //    });
    //    const mediumDialogSubscription = this.isMedium.subscribe(size => {
    //     if(size.matches){
    //       useTemplateDialog.updateSize('70vw','100vh');
    //     }
    //   })
    //   const smallSubscription = this.isSmall.subscribe(size => {
    //     if(size.matches){
    //       useTemplateDialog.updateSize('100vw', '100vh');
    //     }
    //   })
    //   const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
    //     if (size.matches) {
    //       useTemplateDialog.updateSize('100vw', '100vh');
    //     } 
    //     // else {
    //     //   this.matDialogRef.updateSize('50%', '100vh');
    //     // }
    //   });
    //   useTemplateDialog.afterClosed().subscribe((data)=>{
    //     mediumDialogSubscription.unsubscribe()
    //     smallDialogSubscription.unsubscribe()
    //     smallSubscription.unsubscribe()
    //   });
    // });
  }

  viewMomPdfDialog(meetingResp:any){
    let viewMinutes = this.dialog.open(ViewMomDialogComponent,{
      data:{meetingInfo:meetingResp},
      panelClass: ['parent-dialog-container'],
      maxWidth : "100%",
      maxHeight : "100vh",
      minWidth : "80%",
      minHeight : "80vh",
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if(size.matches){
        viewMinutes.updateSize('70vw','100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        viewMinutes.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        viewMinutes.updateSize('100vw', '100vh');
      } 
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    viewMinutes.afterClosed().subscribe((data)=>{
 
      mediumDialogSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });
  }

  saveTemplate(meetingResponse:any){
  
    let saveTemplateDialog = this.dialog.open(SaveTemplateDialogComponent, {
      data:{meetingResponse},
      // position : {
      //   left : "0%"
      // },
      // panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: false,
      // height : "60vh",
      maxWidth: "100%",
      // maxHeight: "100vh",
      width : "50%"
    });
    // const mediumDialogSubscription = this.isMedium.subscribe(size => {
    //   if(size.matches){
    //     saveTemplateDialog.updateSize('50%','');
    //   }
    // })
    const smallSubscription = this.isSmall.subscribe(size => {
      if(size.matches){
        saveTemplateDialog.updateSize('100%', '');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      } 
      else {
        this.matDialogRef.updateSize('50%', 'auto');
      }
    });
    saveTemplateDialog.afterClosed().subscribe((data)=>{
      // mediumDialogSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });
  }

  removePane(number : any){
    this.pinDialogTriggered = false
    this.rightPane = number;
    let matTabBodyWrapper = document.getElementsByClassName('mat-tab-body-wrapper');
    let matTabHeader = document.getElementsByClassName('mat-tab-header');
    matTabHeader[0].removeAttribute('style')
    matTabBodyWrapper[0].removeAttribute('style')
  }

  updateMeetingTitle(meetingId:any){
    if(this.meetingTitleEdit == undefined){
           let title = <HTMLElement>document.getElementById("meeting-title-changer")
           this.meetingTitleEdit=title.innerText;      
    }
    if(this.meetingTitleEdit == ''|| this.meetingTitleEdit.trim().length == 0){
      // let title = <HTMLElement>document.getElementById("meeting-title-changer")
      this.meetingTitleEdit='Untitled Meeting';
      let title = <HTMLElement>document.getElementById("meeting-title-changer")
      title.innerHTML = 'Untitled Meeting'; 
    }
  
    //  this.meetingTitleEdit=<HTMLElement>document.getElementById("meeting-title-changer");
     if(this.duration == undefined &&  this.meetingDateStr == undefined && this.meetingStartTime == undefined){
      
       this.duration = this.meetingResponse.duration;
       this.meetingDateStr = this.meetingResponse.meetingDateShortFormat
       
       if(this.meetingResponse.meetingUTCDate!=null) {
          var curSysDate = new Date(this.meetingResponse.meetingUTCDate);
          var tempDate = new Date(curSysDate.getTime());
          var _utcDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(),  tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds());
          var fullDate = new Date(_utcDate.getTime() + (3600000*(this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
          var hour=this.addZero(fullDate.getHours());
          var minutes=this.addZero(fullDate.getMinutes());
          
          this.meetingStartTime = hour+":"+minutes;
          
       }
       //this.meetingStartTime = this.meetingResponse.meetingStartTime
     }
     
    var meetingTitleJson={
      "meetingTitle": this.meetingTitleEdit,
      "userId":this.globals.userId
    }
    
   
    this.meetingService.updateMeetingTitle(meetingId, meetingTitleJson).subscribe(responsedata => {
      this.callWebsocketService(responsedata)
    });
    this.meetingResponse.meetingTitle=this.meetingTitleEdit
    this.meetingTitleChanges = this.meetingTitleEdit

 }
 addZero(i:any) {
  if (i < 10) {
      i = "0" + i;
  }
  return i;
}
 getMeetingTitle(event : any){
    this.meetingTitleEdit = event.target.innerText;
    let title = <HTMLElement>document.getElementById("meeting-title-changer")
    if(this.meetingTitle == '' || this.meetingTitle == null || this.meetingTitle == undefined){
      title.style.borderLeft = "1px dashed white"
    }
    else{
      title.style.borderBottom = "2px dashed black"
    }
   
 }
 callWebsocketService(responsedata:any){
  this.meetingResponse.addType='A';
  this.meetingResponse.elementType='MEETING';
  this.meetingResponse.meetingTitle= this.meetingTitleEdit
  var selObjId = this.meetingResponse.meetingId;
  this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId,this.meetingResponse).subscribe((data) => {
    
  });
}

}
